<template>
  <div id="gastosRepresentacion">
    <v-layout wrap>
      <v-flex xs3>
        <!-- <v-container>
          <v-menu ref="menuDateStart" :close-on-content-click="false" v-model="menuDateStart" :nudge-right="40"
            :return-value.sync="menuDateStart" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaInicio" label="Fecha Inicio" readonly></v-text-field>
            <v-date-picker v-model="fechaInicio" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateStart = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateStart.save(fechaInicio)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container> -->
      </v-flex>
      <v-flex xs3>
        <!-- <v-container>
          <v-menu ref="menuDateEnd" :close-on-content-click="false" v-model="menuDateEnd" :nudge-right="40"
            :return-value.sync="menuDateEnd" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaFin" label="Fecha Fin" readonly></v-text-field>
            <v-date-picker v-model="fechaFin" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateEnd = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateEnd.save(fechaFin)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container> -->
      </v-flex>
    </v-layout>
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Solicitudes de Representacion</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="newSol()">
            <v-icon>note_add</v-icon>
          </v-btn>
          <span>Nueva Solicitud Representacion</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="solicitudes" :loading="loading" :search="search" class="elevation-1"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" :items-per-page="10">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="{ item }">
          <tr>
            <td class="text-xs-center">{{ item.idsolicitud_gasto_representacion }}</td>
            <td class="text-xs-center">{{ item.nombre_responsable }}</td>
            <td class="text-xs-center">{{ mapTipoGasto(item.tipo_gasto) }}</td>
            <td class="text-xs-center">{{ item.idcat_estatus.estatus }}</td>
            <td class="text-xs-center">{{ formatCurrency(item.importe) }}</td>
            <td class="text-xs-center">{{ formatDate(item.fecha_creacion) }} </td>
            <td class="text-xs-center">{{ formatDate(item.fecha_actualizacion) }} </td>
            <td class="text-xs-center"> <v-tooltip bottom>
                <v-btn slot="activator" small icon @click="showDetailRep(item.idsolicitud_gasto_representacion)">
                  <v-icon>description</v-icon>
                </v-btn>
                <span>Ver Detalles</span>
              </v-tooltip></td>
          </tr>
        </template>
        <template slot="no-data">
          <div class="text-xs-center">No hay solicitudes registradas.</div>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="alert" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="questionReq" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ showDetail ? '¿Desea actualizar la solicitud?' : '¿Desea guardar la nueva solicitud?'
          }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionReq = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="showDetail ? updateSol() : saveSol()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmCloseReq" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">¿Está seguro que desea salir?</v-card-title>
        <v-card-text>
          Va a cerrar esta ventana. Perderá los cambios capturados.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="confirmClose()">Salir</v-btn>
          <v-btn color="green" dark @click="confirmCloseReq = false">Mantenerse en solicitud</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewReq" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="confirmCloseReq = true">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title> <span>{{ showDetail ? 'Detalle Solicitud Representacion:' : 'Nueva Solicitud Representacion'
          }} <strong v-if="showDetail">{{ idsolicitud }}</strong></span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip v-if="showDetail" left>
            <v-btn slot="activator" :loading="loading" icon dark @click="printSolicitud()">
              <v-icon>local_printshop</v-icon>
            </v-btn>
            <span>Imprimir</span>
          </v-tooltip>
          <v-toolbar-items v-if="enableUpdate">
            <v-btn dark flat :loading="loading" @click="checkQuestionReq()">{{ showDetail ? 'Actualizar' : 'Guardar'
            }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- reemplaza el bloque del dialog por este -->
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout wrap class="no-gutters">
              <!-- Columna 1 -->
              <v-flex xs12 sm4 md4>
                <!-- 🔹 Mantengo todo tu contenido original de la columna 1 -->
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Tipo de gastos
                </div>
                <v-radio-group v-model="solicitud.tipo_gasto" :mandatory="false"
                  @input="$v.solicitud.tipo_gasto.$touch()" @blur="$v.solicitud.tipo_gasto.$touch()">
                  <v-radio label="Gastos de representación" color="primary" value="representacion" />
                  <v-radio label="Gastos de atención al personal" color="primary" value="atencion_personal" />
                  <v-radio-group v-if="solicitud.tipo_gasto == 'atencion_personal'" v-model="solicitud.tipo_atencion"
                    @input="$v.solicitud.tipo_atencion.$touch()" @blur="$v.solicitud.tipo_atencion.$touch()"
                    :mandatory="false" class="ml-5 mt-neg">
                    <div slot="label"><strong>Tipo de atencion</strong></div>
                    <v-radio label="Comida de Trabajo" value="comidas_trabajo" />
                    <v-radio label="Reuniones de Integración" value="reuniones_integracion" />
                  </v-radio-group>
                </v-radio-group>

                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Tipo de pago
                </div>
                <v-radio-group v-model="solicitud.tipo_pago" :mandatory="false" @input="$v.solicitud.tipo_pago.$touch()"
                  @blur="$v.solicitud.tipo_gasto.$touch()">
                  <v-radio label="Transferencia" color="primary" value="transferencia" />
                  <v-radio label="Cheque" color="primary" value="cheque" />
                </v-radio-group>

                <br>
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Datos de depósito
                </div>
                <!-- Banco -->
                <v-text-field class="deposito-field" v-model="solicitud.banco" disabled :error-messages="bancoErrors"
                  @input="$v.solicitud.banco.$touch()" @blur="$v.solicitud.banco.$touch()" label="Banco" />

                <!-- No. Cuenta -->
                <v-text-field class="deposito-field" v-model="solicitud.cuenta" disabled :error-messages="cuentaErrors"
                  @input="$v.solicitud.cuenta.$touch()" @blur="$v.solicitud.cuenta.$touch()" label="No. Cuenta" />

                <!-- No. Tarjeta -->
                <v-text-field class="deposito-field" v-model="solicitud.tarjeta" disabled
                  :error-messages="tarjetaErrors" @input="$v.solicitud.tarjeta.$touch()"
                  @blur="$v.solicitud.tarjeta.$touch()" label="No. Tarjeta" />

                <!-- Referencia Interbancaria -->
                <v-text-field class="deposito-field" v-model="solicitud.clabe" disabled :error-messages="clabeErrors"
                  @input="$v.solicitud.clabe.$touch()" @blur="$v.solicitud.clabe.$touch()"
                  label="Referencia Interbancaria" />

              </v-flex>

              <!-- Columna 2 -->
              <v-flex xs12 sm4 md4>
                <!-- 🔹 Mantengo todo tu contenido original de la columna 2 -->
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Responsable
                </div>
                <v-text-field v-model="solicitud.nombre" :error-messages="nombreErrors" disabled
                  @input="$v.solicitud.nombre.$touch()" @blur="$v.solicitud.nombre.$touch()" label="Nombre" />
                <v-select v-model="solicitud.puesto" :error-messages="puestoErrors" :items="catalogos.puestos" disabled
                  :item-text="centroText" item-value="idcat_puesto" label="Puesto" @input="$v.solicitud.puesto.$touch()"
                  @blur="$v.solicitud.puesto.$touch()" />
                <v-select v-model="solicitud.departamento" :error-messages="departamentoErrors" disabled
                  :items="catalogos.departamentos" :item-text="centroText" item-value="idcat_departamento"
                  label="Departamento" @input="$v.solicitud.departamento.$touch()"
                  @blur="$v.solicitud.departamento.$touch()" />
                <v-select v-model="solicitud.direccion" :error-messages="direccionErrors" :items="catalogos.direcciones"
                  disabled :item-text="centroText" item-value="idcat_direccion" label="Plaza"
                  @input="$v.solicitud.direccion.$touch()" @blur="$v.solicitud.direccion.$touch()" />
                <v-select v-model="solicitud.empresa" :error-messages="empresaErrors" :items="catalogos.empresas"
                  disabled :item-text="centroText" item-value="idcat_empresa" label="Empresa"
                  @input="$v.solicitud.empresa.$touch()" @blur="$v.solicitud.departamento.$touch()" />
                <v-combobox v-model="solicitud.centro" :error-messages="centroErrors" :items="catalogos.centros"
                  :item-text="centroText" item-value="idcat_centro_costo" label="Centro de costos"
                  @input="$v.solicitud.centro.$touch()" @blur="$v.solicitud.centro.$touch()" :disabled="!enableUpdate"
                  clearable filterable return-object />
                <v-text-field v-model="solicitud.asistentes" :error-messages="asistentesErrors"
                  @input="$v.solicitud.asistentes.$touch()" @blur="$v.solicitud.asistentes.$touch()"
                  label="No. Asistentes" type=" number" />

                <h3 class="grey--text firmas-titulo">FIRMAS DE APROBACION</h3><br />
                <v-list three-line dark class="firmas-list">
                  <template v-for="(item, i) in firmas">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                          v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < firmas.length"></v-divider>
                  </template>
                </v-list>
              </v-flex>

              <!-- Columna 3 -->
              <v-flex xs12 sm4 md4>
                <!-- 🔹 Mantengo todo tu contenido original de la columna 3 -->
                <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                  Detalle de pago
                </div>
                <v-text-field v-model="solicitud.importe" :error-messages="importeErrors"
                  @input="$v.solicitud.importe.$touch()" @blur="$v.solicitud.importe.$touch()" label="Importe"
                  prefix="$" suffix="MXN" type="number" />
                <v-text-field v-model="solicitud.importe_letra" :value="importeLetra" disabled
                  label="Importe con letra" />
                <v-textarea v-model="solicitud.observaciones" :error-messages="observacionesErrors"
                  @input="$v.solicitud.observaciones.$touch()" @blur="$v.solicitud.observaciones.$touch()"
                  label="Observaciones" rows="8" auto-grow />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import numeroALetras from '@/assets/js/NumeroALetras.js';
import services from "@/config/services";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";

export default {
  name: "GastosRepresentacion",
  mixins: [validationMixin],
  validations: {
    solicitud: {
      observaciones: {
        required: requiredIf(function () {
          return true;
        })
      },
      asistentes: {
        required: requiredIf(function () {
          return true;
        })
      },
      importe: {
        required: requiredIf(function () {
          return true;
        })
      },
      nombre: {
        required: requiredIf(function () {
          return true;
        })
      },
      tipo_atencion: {
        required: requiredIf(function () {
          if (this.solicitud.tipo_gasto == 'atencion_personal') {
            return true;
          }
        })
      },
      tipo_pago: {
        required: requiredIf(function () {
          return true;
        })
      },
      tipo_gasto: {
        required: requiredIf(function () {
          return true;
        })
      },
      centro: {
        required: requiredIf(function () {
          return true;
        })
      },
      direccion: {
        required: requiredIf(function () {
          return true;
        })
      },
      empresa: {
        required: requiredIf(function () {
          return true;
        })
      },
      departamento: {
        required: requiredIf(function () {
          return true;
        })
      },
      puesto: {
        required: requiredIf(function () {
          return true;
        })
      },
      banco: {
        required: requiredIf(function () {
          return true;
        })
      },
      cuenta: {
        required: requiredIf(function () {
          return true;
        })
      },
      tarjeta: {
        required: requiredIf(function () {
          return true;
        })
      },
      clabe: {
        required: requiredIf(function () {
          return true;
        })
      }
    }
  },
  data() {
    return {
      idsolicitud: null,
      showDetail: false,
      catalogos: null,
      firmas: [],
      detalleAMEX: {
        empresa: {},
        centro_costo: {},
        direccion: {},
        departamento: {}

      },
      enableUpdate: true,
      detalle: null,
      questionReq: false,
      confirmCloseReq: false,
      msgError: "",
      msgSuccess: "",
      success: false,
      dialogNewReq: false,
      loading: false,
      alert: false,
      search: "",
      solicitudes: [],
      estados_cuenta: [],
      menuDateStart: false,
      menuDateEnd: false,
      fechaInicio: "",
      fechaFin: "",
      dialogResumen: false,
      resumenTarjetahabientes: [],
      pagination: {
        rowsPerPage: 7
      },
      headers: [
        { text: "ID", sortable: false, class: 'text-xs-center' },
        { text: "Usuario", sortable: false, class: 'text-xs-center' },
        { text: "Tipo de gasto", sortable: false, class: 'text-xs-center' },
        { text: "Estatus", sortable: false, class: 'text-xs-center' },
        { text: "Importe", sortable: false, class: 'text-xs-center' },
        { text: "Fecha de Registro", sortable: false, class: 'text-xs-center' },
        { text: "Fecha de Actualizacion", sortable: false, class: 'text-xs-center' },
        { text: "Acciones", sortable: false, class: 'text-xs-center' },

      ],
      solicitud: {
      },
      catalogos: {
        centros: [],
        direcciones: [],
        empresas: [],
        departamentos: [],
        puestos: []
      }
    };
  },
  computed: {
    importeLetra() {
      if (this.solicitud.importe !== '') {
        this.solicitud.importe_letra = numeroALetras(this.solicitud.importe, {
          plural: 'PESOS',
          singular: 'PESO',
          centPlural: 'CENTAVOS',
          centSingular: 'CENTAVO'
        })
      }
      else {
        this.solicitud.letra = ''
      }
    },
    observacionesErrors() {
      const errors = [];
      if (!this.$v.solicitud.asistentes.$dirty) return errors;
      !this.$v.solicitud.asistentes.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    asistentesErrors() {
      const errors = [];
      if (!this.$v.solicitud.asistentes.$dirty) return errors;
      !this.$v.solicitud.asistentes.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    importeErrors() {
      const errors = [];
      if (!this.$v.solicitud.importe.$dirty) return errors;
      !this.$v.solicitud.importe.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.solicitud.nombre.$dirty) return errors;
      !this.$v.solicitud.nombre.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tipoGastoErrors() {
      const errors = [];
      if (!this.$v.solicitud.tipo_gasto.$dirty) return errors;
      !this.$v.solicitud.tipo_gasto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    centroErrors() {
      const errors = [];
      if (!this.$v.solicitud.centro.$dirty) return errors;
      !this.$v.solicitud.centro.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    direccionErrors() {
      const errors = [];
      if (!this.$v.solicitud.direccion.$dirty) return errors;
      !this.$v.solicitud.direccion.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    empresaErrors() {
      const errors = [];
      if (!this.$v.solicitud.empresa.$dirty) return errors;
      !this.$v.solicitud.empresa.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    departamentoErrors() {
      const errors = [];
      if (!this.$v.solicitud.departamento.$dirty) return errors;
      !this.$v.solicitud.departamento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    puestoErrors() {
      const errors = [];
      if (!this.$v.solicitud.puesto.$dirty) return errors;
      !this.$v.solicitud.puesto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    bancoErrors() {
      const errors = [];
      if (!this.$v.solicitud.banco.$dirty) return errors;
      !this.$v.solicitud.banco.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    cuentaErrors() {
      const errors = [];
      if (!this.$v.solicitud.cuenta.$dirty) return errors;
      !this.$v.solicitud.cuenta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    }
    ,
    tarjetaErrors() {
      const errors = [];
      if (!this.$v.solicitud.tarjeta.$dirty) return errors;
      !this.$v.solicitud.tarjeta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    }
    ,
    clabeErrors() {
      const errors = [];
      if (!this.$v.solicitud.clabe.$dirty) return errors;
      !this.$v.solicitud.clabe.required &&
        errors.push("El campo es obligatorio");
      return errors;
    }
  },
  async mounted() {
    this.setDates();
    await this.fetchSolicitudes();
    const id = this.$route.params.idsolicitud;
    if (id) {
      this.showDetailRep(id)
    }
  },
  methods: {
    mapTipoGasto(value) {
      const map = {
        representacion: 'Gastos de representación',
        atencion_personal: 'Atención al personal'
      }
      return map[value] || value
    },
    formatDateTimeCDMX(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    formatPeriodo(periodo) {
      if (!periodo || periodo.length !== 6) return "";
      const year = periodo.slice(0, 4);
      const month = periodo.slice(4, 6);
      return `${year}-${month}`;
    },
    closeDetailRep() {
      this.resetDetalle()
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const options = { day: '2-digit', month: 'short', year: 'numeric' };
      const parts = new Date(date).toLocaleDateString('es-MX', options).split(' ');

      const dia = parts[0];
      const mes = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
      const anio = parts[2];

      return `${dia}-${mes}-${anio}`;
    },
    resetDetalle() {
      this.detalleAMEX = {
        empresa: {},
        centro_costo: {},
        direccion: {},
        departamento: {}
      }
    },
    reset() {
      this.solicitud = {
        centro: null,
        direccion: null,
        empresa: null,
        departamento: null,
        puesto: null,
      };
      this.$v.$reset();
    },
    centroText(item) {
      if (!item) return '';
      const idField = item.idexterno;
      return `${idField} - ${item.descripcion}`;
    },
    printSolicitud() {
      this.loading = true;
      const pdfWindow = window.open("", "_blank");
      if (pdfWindow) {
        pdfWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Generando PDF...</title>
            <style>
              body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; background: #f5f5f5; }
              .loader-container { text-align: center; }
              .spinner { border: 4px solid #e0e0e0; border-top: 4px solid #1976d2; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite; margin: 0 auto 20px; }
              @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
              h2 { color: #333; margin-bottom: 10px; }
              p { color: #666; }
            </style>
          </head>
          <body>
            <div class="loader-container">
              <div class="spinner"></div>
              <h2>Generando PDF</h2>
              <p>Por favor espere, esto puede tomar unos segundos...</p>
            </div>
          </body>
          </html>
        `);
        pdfWindow.document.close();
      }
      const jwt = this.$session.get("jwt");
      const headers = { Authorization: "Bearer " + jwt };
      const url = services.routes.impresionDetalleSolicitudRepresentacion +
        "?idsolicitud=" + this.idsolicitud;
      axios.get(url, { headers })
        .then(response => {
          const res = response.data;
          if (res.correcto) {
            this.success = true;
            this.msgSuccess = res.mensaje;
            if (pdfWindow) {
              pdfWindow.location.href = res.data;
            } else {
              window.open(res.data, "_blank");
            }
          } else {
            if (pdfWindow) {
              pdfWindow.close();
            }
            this.error = true;
            this.msgError = res.mensaje;
          }
        })
        .catch(err => {
          if (pdfWindow) {
            pdfWindow.close();
          }
          this.error = true;
          this.msgError = "Error al generar el PDF";
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async showDetailRep(id) {
      this.idsolicitud = id
      this.showDetail = true
      this.solicitud = {
        tipo_gasto: null,
        importe: null,
        importe_letra: null,
        numero_asistentes: null,
        observaciones: null,
      }
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.representacionSolicitudesDetalle.replace(
          ":id",
          id
        );
        const { data } = await axios.get(url, { headers });
        await this.loadCatalogs()

        const userid = this.$session.get("userid");
        if (data.idcat_estatus.idcat_estatus == 4 && data.idusuario_creacion == userid) {
          this.enableUpdate = true
        } else {
          this.enableUpdate = false
        }

        this.solicitud.tipo_gasto = data.tipo_gasto
        if (this.solicitud.tipo_gasto == 'atencion_personal') {
          this.solicitud.tipo_atencion = data.subtipo_atencion
        }
        this.solicitud.tipo_pago = data.tipo_pago
        this.solicitud.banco = data.banco
        this.solicitud.cuenta = data.numero_cuenta
        this.solicitud.tarjeta = data.numero_tarjeta
        this.solicitud.clabe = data.referencia_interbancaria
        this.solicitud.nombre = data.nombre_responsable

        const puesto = this.catalogos.puestos.find(
          e => e.descripcion === data.puesto
        );
        if (puesto) {
          this.solicitud.puesto = puesto.idcat_puesto;
        }
        this.solicitud.departamento = data.idcat_departamento
        this.solicitud.direccion = data.idcat_direccion
        this.solicitud.empresa = data.idcat_empresa

        // Busca el centro en el catálogo
        const centro = this.catalogos.centros.find(
          e => e.idcat_centro_costo === data.idcat_centro_costo.idcat_centro_costo
        );
        if (centro) {
          this.solicitud.centro = centro;
        }
        this.solicitud.asistentes = data.numero_asistentes
        this.solicitud.importe = data.importe
        this.solicitud.observaciones = data.observaciones
        this.solicitud.importe_letra = data.importe_letra
        this.firmas = data.firmas

        this.dialogNewReq = true;
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {

        this.loading = false;
      }
    },
    setDates() {
      const hoy = new Date();
      const tresMesesAntes = new Date(hoy.setMonth(hoy.getMonth() - 3));
      this.fechaInicio = tresMesesAntes.toISOString().slice(0, 10);
      this.fechaFin = new Date().toISOString().slice(0, 10);
    },
    async fetchSolicitudes() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };

        let detalleUsuario = await axios.get(services.routes.detalleUsuario, {
          headers
        });

        let detalleUsuarioData = detalleUsuario.data.data

        this.detalle = {
          departamento: detalleUsuarioData.detalle.departamento,
          direccion: detalleUsuarioData.detalle.direccion,
          empresa: detalleUsuarioData.detalle.empresa,
          puesto: detalleUsuarioData.detalle.puesto,
          banco: detalleUsuarioData.detalle.nomina_banco,
          cuenta: detalleUsuarioData.detalle.nomina_cuenta,
          tarjeta: detalleUsuarioData.detalle.nomina_tarjeta,
          clabe: detalleUsuarioData.detalle.personal_clabe,
          nombre: `${detalleUsuarioData.detalle.nombre} ${detalleUsuarioData.detalle.apellido_paterno} ${detalleUsuarioData.detalle.apellido_materno}`
        };

        const { data } = await axios.get(
          services.routes.representacionSolicitudesList,
          { headers }
        );
        this.solicitudes = data;
      } catch (err) {
        console.error("Error al cargar solicitudes:", err);
      } finally {
        this.loading = false;
      }
    },
    refresh() {
      this.fetchSolicitudes();
    },
    formatDateTable(date) {
      if (!date) return "";
      const options = {
        timeZone: "America/Mexico_City",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      };
      const formatter = new Intl.DateTimeFormat("es-MX", options);
      const formatted = formatter.format(new Date(date));
      const [dia, mes, anio, hora] = formatted.replace(",", "").split(" ");
      const mesUpper = mes.toUpperCase();
      return `${dia}-${mesUpper}-${anio} ${hora}`;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = n => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    formatCurrency(amount) {
      if (isNaN(amount)) return "$0.00";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },

    async loadCatalogs() {
      const jwt = this.$session.get("jwt");
      const headers = { Authorization: "Bearer " + jwt };

      let centros = await axios.post(
        services.routes.obtenerCatalogo,
        { tableName: "cat_centros_costos" },
        { headers }
      );
      this.catalogos.centros = centros.data.data.datos;
      let direcciones = await axios.post(
        services.routes.obtenerCatalogo,
        { tableName: "cat_direcciones" },
        { headers }
      );
      this.catalogos.direcciones = direcciones.data.data.datos;
      let empresas = await axios.post(
        services.routes.obtenerCatalogo,
        { tableName: "cat_empresas" },
        { headers }
      );
      this.catalogos.empresas = empresas.data.data.datos;
      this.catalogos.empresas = this.catalogos.empresas.filter(e => e.idcat_estatus == 1);
      let departamentos = await axios.post(
        services.routes.obtenerCatalogo,
        { tableName: "cat_departamentos" },
        { headers }
      );
      this.catalogos.departamentos = departamentos.data.data.datos;
      let puestos = await axios.post(
        services.routes.obtenerCatalogo,
        { tableName: "cat_puestos" },
        { headers }
      );
      this.catalogos.puestos = puestos.data.data.datos;
    },

    async newSol() {
      this.enableUpdate = true
      this.showDetail = false
      this.loading = true;
      try {

        await this.loadCatalogs()

        const empresa = this.catalogos.empresas.find(
          e => e.descripcion === this.detalle.empresa
        );
        if (empresa) {
          this.solicitud.empresa = empresa.idcat_empresa;
        }

        const dirreccion = this.catalogos.direcciones.find(
          e => e.descripcion === this.detalle.direccion
        );
        if (dirreccion) {
          this.solicitud.direccion = dirreccion.idcat_direccion;
        }

        const departamento = this.catalogos.departamentos.find(
          e => e.descripcion === this.detalle.departamento
        );
        if (departamento) {
          this.solicitud.departamento = departamento.idcat_departamento;
        }
        const puesto = this.catalogos.puestos.find(
          e => e.descripcion === this.detalle.puesto
        );
        if (puesto) {
          this.solicitud.puesto = puesto.idcat_puesto;
        }

        this.solicitud.nombre = this.detalle.nombre
        this.solicitud.banco = this.detalle.banco
        this.solicitud.cuenta = this.detalle.cuenta
        this.solicitud.tarjeta = this.detalle.tarjeta
        this.solicitud.clabe = this.detalle.clabe

        this.dialogNewReq = true;
      } catch (err) {
        console.error("Error al catalogos:", err);
      } finally {
        this.loading = false;
      }
    },
    checkQuestionReq() {
      this.$v.$touch();
      this.questionReq = false;
      if (this.$v.$invalid) return;
      this.questionReq = true;
    },
    async updateSol() {
      this.loading = true;
      this.questionReq = false;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        let data = {
          idsolicitud: this.idsolicitud,
          tipo_gasto: this.solicitud.tipo_gasto,
          subtipo_atencion: this.solicitud.tipo_atencion,
          tipo_pago: this.solicitud.tipo_pago,
          idcat_centro_costo: this.solicitud.centro.idcat_centro_costo || this.solicitud.centro,
          numero_asistentes: Number(this.solicitud.asistentes),
          importe: Number(this.solicitud.importe),
          importe_letra: this.solicitud.importe_letra,
          observaciones: this.solicitud.observaciones,
        }

        let res = await axios.post(services.routes.representacionSolicitudesUpdate, data, {
          headers
        });
        this.reset();
        this.close();
        this.refresh();
        this.success = true;
        this.msgSuccess = "Solicitud actualizada correctamente";
      } catch (err) {
        this.loading = false;
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
      } finally {
        this.loading = false;
      }
    },
    async saveSol() {
      this.questionReq = false;
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };

        const puesto = this.catalogos.puestos.find(
          e => e.idcat_puesto == this.solicitud.puesto
        );
        if (puesto) {
          this.solicitud.puesto = puesto.descripcion;
        }

        let data = {
          tipo_gasto: this.solicitud.tipo_gasto,
          subtipo_atencion: this.solicitud.tipo_atencion,
          tipo_pago: this.solicitud.tipo_pago,
          nombre_responsable: this.solicitud.nombre,
          puesto: this.solicitud.puesto,
          idcat_empresa: this.solicitud.empresa,
          idcat_direccion: this.solicitud.direccion,
          idcat_departamento: this.solicitud.departamento,
          idcat_centro_costo: this.solicitud.centro.idcat_centro_costo || this.solicitud.centro,
          numero_asistentes: Number(this.solicitud.asistentes),
          banco: this.solicitud.banco,
          numero_cuenta: this.solicitud.cuenta,
          numero_tarjeta: this.solicitud.tarjeta,
          referencia_interbancaria: this.solicitud.clabe,
          importe: Number(this.solicitud.importe),
          importe_letra: this.solicitud.importe_letra,
          observaciones: this.solicitud.observaciones,
        };

        let res = await axios.post(services.routes.representacionSolicitudesCreate, data, {
          headers
        });
        this.reset();
        this.close();
        this.refresh();
        this.success = true;
        this.msgSuccess = "Solicitud guardada correctamente";
      } catch (err) {
        this.loading = false;
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
      } finally {
        this.loading = false;
      }
    },
    confirmClose() {
      this.reset();
      this.dialogNewReq = false;
      this.confirmCloseReq = false;
    },
    confirmDeleteEstadoCuenta(item) {
      this.estadoCuentaSeleccionado = item;
      this.dialogDeleteEC = true;
    },

    close() {
      this.$v.$reset();
      this.confirmCloseReq = false;
      this.dialogNewReq = false;
    },
  }
};
</script>


<style scoped>
.v-text-field {
  max-width: 85% !important;
  /* puedes ajustar a 70%, 60% según te guste */
  margin-left: auto;
  margin-right: auto;
}

.deposito-field {
  margin-left: 0 !important;
  /* Alinea a la izquierda */
  margin-right: auto !important;
}

/* inputs/selecciones más angostos y centrados */
.titulo-centrado {
  width: 100%;
  text-align: center;
}

.mt-neg {
  margin-top: 10px;
}

.no-gutters {
  margin: 0 !important;
}

.no-gutters>.v-flex {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.firmas-titulo {
  text-align: center;
  margin-bottom: 8px;
}

/* Hacer que el v-list mida lo mismo que los v-text-field */
.firmas-list {
  max-width: 85%;
  /* 🔁 usa el mismo % que tus .v-text-field */
  margin-left: auto;
  margin-right: auto;
}

/* (Opcional) Alinear borde visual con inputs reduciendo padding lateral */
.firmas-list .v-list__tile,
.firmas-list .v-list-tile {
  padding-left: 0;
  padding-right: 0;
}
</style>
